import React, { Component } from 'react';
import InternetNavigatorPane from 'components/discover/InternetNavigatorPane.js';
import SampleSource from 'components/discover/SampleSource.js';

class SamplerDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                To add samples to Zequencer, go to the <a href="https://zequencer.io/discover/">Sampler page</a>.
              </p>
              <p className="sub-header">
                Setting Up Audio Routing
              </p>
              <p>
                <ol>
                  <li>
                    First install <a href="https://soundflower.en.softonic.com/mac/download">soundflower</a>, which
            routes audio from your system output to an input.
                  </li>
                <li>
                Go to Audio MIDI Setup on Mac OSX.
                </li>
                <li>
                Go to the "Window" menu and select "Audio Devices"
                </li>
                <li>
                Press the "+" button and select "Create Multi-Output Device".
                </li>
                <li>
                Check "Soundflower (2ch)" and "Built-In Output"
                </li>
                <li>
                Finally, set your system audio output to the newly created Multi-Output Device.
                </li>
                </ol>
              </p>
              <p className="sub-header">
                Youtube
              </p>
              <p>
                On the sampler page, you can search for youtube videos to sample.
              </p>
              <p className="sub-header">
                Vinyl
              </p>
              <p>
                If you want to record vinyl samples, choose the audio input from the dropdown.
                Then select the "vinyl" checkbox. This will allow you to monitor the input
            of your recording.

                <div className="sample-source-demo">
                  <SampleSource onSampleSourceChange={() => []} onChooseAudio={(input) => []} />
                </div>
                <div className="clear-fix"/>
              </p>
              <p>
                With "vinyl" selected, go to the "Discogs" tab and type the title of your
            record in the search box. Then select the matching sample. This will tie whatever
            samples you record to the record.
              </p>
              <p className="sub-header" >
                Recording
              </p>
              <p>
                To record a sample, click the <b>RECORD</b> button and when you're done click it again.
                You will notice the recorded sample appear below
              </p>
              <p className="sub-header">
                Tagging Samples
              </p>
              <p>
                Setting tags for samples allows you to organize your sample library.
                Click on the cover art of your recorded samples to select them. Once
            selected, press the <b>TAG</b> button. Then type the tag in the input field and
            press ENTER.
              </p>
              <p className="sub-header">
                Saving
              </p>
              <p>
                Once you've tagged your samples, you need to press the <b>SAVE SOUNDS</b> button.
                <p>
                A <b>Metamask</b> pop-up will show up confirming you wish to save. The transaction
            cost will be proportional to the number of samples you've recorded.
                </p>
                <p>
                The transaction cost is roughly 1 cent per sample.
                </p>
              </p>
              <p className="sub-header">
                Searching for Samples
              </p>
              <p>
                It's important to tie samples you record to the source you've found them from.
              </p>
              <p>
                For youtube samples, this happens automatically. However if you sample directly
            from vinyl, you need to tie the sample from the <b>Discogs</b> tab. Type the name
            of the record in the search box and click the result closest matching your record.
                
                <InternetNavigatorPane
                  store={this.props.sequencerEngine.store}
                  videoId={''}
                  onClickResult={(result) => []}
                />
              </p>
            </div>
        );
    }
}

export default SamplerDocumentation;
